"use client";

import { jsx as a, jsxs as h } from "react/jsx-runtime";
import { useState as b, useEffect as f } from "react";
import { createPortal as y } from "react-dom";
import g from './../../external/react-focus-lock/dist/es2015/Combination.js';
import { classNames as p } from "../../utilities/index.js";
import "./index.css.js";
const n = _ref => {
    let {
      width: l,
      effect: e = "fadein",
      align: s,
      children: t,
      isOpen: r,
      onClose: d,
      className: c,
      backdropClass: m,
      ...x
    } = _ref;
    const [u, C] = b(null);
    f(() => {
      let o = document.getElementById("portal") || null;
      o || (o = document.createElement("div"), o.setAttribute("id", "portal"), document.body.appendChild(o));
      const i = document.createElement("div");
      return o == null || o.appendChild(i), C(i), () => {
        o == null || o.removeChild(i);
      };
    }, []);
    const v = p({
        "sash-Modal relative bg-white mx-auto my-14 max-w-xl transition-all duration-500 overflow-hidden": !0,
        "sash-Modal--fadeIn": e === "fadein",
        "sash-Modal--scaleUp": e === "scaleup",
        "sash-Modal--scaleDown": e === "scaledown",
        "sash-Modal--slideDown": e === "slidedown",
        "sash-Modal--slideUp": e === "slideup",
        "flex-auto mx-auto": s === "center",
        "sash-Modal--slideDownCentered": s === "center" && e === "slidedown",
        "sash-Modal--slideUpCentered": s === "center" && e === "slideup",
        [c]: c
      }),
      w = p({
        "sash-Modal-Overlay fixed top-0 left-0 z-20 h-full w-full overflow-y-auto overflow-x-hidden overscroll-contain bg-gray-80/70 px-6 transition-all duration-300": !0,
        "flex flex-row items-center": s === "center",
        [m]: m
      }),
      M = /* @__PURE__ */h("button", {
        className: "sash-Modal-Close absolute right-4 top-4 z-[2] h-6 w-6 cursor-pointer",
        onClick: d,
        children: [/* @__PURE__ */a("span", {
          className: "block bg-black text-3xl font-normal leading-6 text-white",
          children: "×"
        }), /* @__PURE__ */a("span", {
          className: "sr-only",
          children: "Close"
        })]
      });
    return !u || !r ? null : y(/* @__PURE__ */a(g, {
      returnFocus: !0,
      children: /* @__PURE__ */a("div", {
        className: w,
        "aria-hidden": !r,
        children: /* @__PURE__ */h("div", {
          className: v,
          role: "dialog",
          "aria-modal": "true",
          style: {
            maxWidth: l
          },
          ...x,
          children: [M, t]
        })
      })
    }), u);
  },
  N = _ref2 => {
    let {
      headingLevel: l = 2,
      children: e,
      className: s,
      ...t
    } = _ref2;
    const r = `sash-ModalHeader border-b border-b-gray-15 py-4 pl-6 pr-16 ${s || ""}`,
      d = `h${l}`;
    return /* @__PURE__ */a("div", {
      className: r,
      ...t,
      children: /* @__PURE__ */a(d, {
        className: "m-0 text-2xl !leading-none",
        children: e
      })
    });
  },
  F = _ref3 => {
    let {
      className: l,
      children: e,
      ...s
    } = _ref3;
    const t = `sash-ModalContent p-6 ${l || ""}`;
    return /* @__PURE__ */a("div", {
      className: t,
      ...s,
      children: e
    });
  },
  $ = _ref4 => {
    let {
      className: l,
      children: e,
      ...s
    } = _ref4;
    const t = `sash-ModalFooter border-t border-t-gray-15 py-4 px-6 ${l || ""}`;
    return /* @__PURE__ */a("div", {
      className: t,
      ...s,
      children: e
    });
  };
n.Header = N;
n.Content = F;
n.Footer = $;
const j = n;
export { j as default };